<script>
import resources from './resources'

export default {
  name: 'change-password',
  mixins: [resources],
  resourcePath: '/v1/settings/users/me/password',
  data () {
    return {
      show: false
    }
  }
}
</script>

<template lang="pug">
  .card
    .header
      h2
        strong Alterar
        |  Senha
    .body
      .form-group
          input.form-control(
            type='password',
            placeholder='Senha atual',
            v-model="password.current",
          )

      .form-group
          input.form-control(
            type='password',
            placeholder='Nova Senha',
            v-model="password.password",
          )

      .form-group
          input.form-control(
            type='password',
            placeholder='Confirme sua nova senha',
            v-model="password.confirmed",
          )

      button.btn.btn-info.btn-round(@click.prevent="doSave()") Salvar
  //-.collapsible-2.collapse
    .form-group.panel-body
      medibook-alert(:show='show',
      @hide='show = false',
      button-action="OK!",
      message='Sua senha foi alterada com sucesso.')
      .row.senhas
        .col-xs-12.col-sm-4.margin-bottom
          label(for='senha')
            | Senha Atual
            br
          f-text(
            type="password",
            v-model="password.current_password",
            :errors="errors['current_password']"
            label="")

        .col-xs-12.col-sm-4
          f-text(
            type="password",
            v-model="password.password",
            :errors="errors['password']",
            label="Nova senha")

        .col-xs-12.col-sm-4
          f-text(
            type="password",
            v-model="password.confirmed",
            :errors="errors['confirmed']",
            label="Confirme sua nova senha")
      .row
        .col-xs-12.col-sm-12.margin-bottom
          small.text-muted.senha-tip
            strong A senha deve conter 1 número e no mínimo 8 caracteres.
      button.btn.save.pull-right(@click.prevent="doSave()")
        span.icon 
        |  Salvar
</template>



// WEBPACK FOOTER //
// src/app/dweller/profile/me/components/change-password/change-password.vue